import { render, staticRenderFns } from "./room.vue?vue&type=template&id=230d4af0&scoped=true&"
import script from "./room.vue?vue&type=script&lang=js&"
export * from "./room.vue?vue&type=script&lang=js&"
import style0 from "./room.vue?vue&type=style&index=0&id=230d4af0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "230d4af0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\00_GIT\\hotel\\hotel-front-admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('230d4af0')) {
      api.createRecord('230d4af0', component.options)
    } else {
      api.reload('230d4af0', component.options)
    }
    module.hot.accept("./room.vue?vue&type=template&id=230d4af0&scoped=true&", function () {
      api.rerender('230d4af0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/hotel/room.vue"
export default component.exports